module.exports = __webpack_public_path__ + "img/Paladin.60c2b62c.png";